module.exports = __webpack_public_path__ + "img/nimin.bf0a7fda.png";